// extracted by mini-css-extract-plugin
module.exports = {"profileForm":"edit-user_profileForm__EVRQY","footer":"edit-user_footer__2OL1I"};